import { ElencoDominioRequest } from '../../../api/generated/dob';
import apiManager from '../../../api/api-manager';
import { genericApiError, isAxiosResponseOk } from '../../../api/api-common';
import { getAPIRequestHeaders } from '../../../utils/api-utils';

export const utilityRepository = {
  getDominio: async (elencoDominioRequest: ElencoDominioRequest, thunkApi) => {
    const response = await apiManager.dobUtilityApi.getDominio(
      elencoDominioRequest,
      getAPIRequestHeaders(thunkApi, { Accept: 'application/json' })
    );

    if (!isAxiosResponseOk(response)) {
      return genericApiError();
    } else {
      return response.data;
    }
  },
};
